import { useState, useCallback } from "react";
 
export const renderOptions = (options, criteria, fallbackData = []) => {
    const hasMatchingOption = options?.find((item) => item.name === criteria?.name && item.status);
    if (hasMatchingOption && hasMatchingOption.data && Array.isArray(hasMatchingOption.data)) {
        const itemData = hasMatchingOption.data;
        const filteredData = itemData
            .filter(subItem => subItem.status === "active" && subItem.flag === true)
            .map(subItem => ({
                label: subItem.name,
                value: subItem.name
            }));
        if (filteredData.length > 0) {
            return filteredData.map((subItem, index) => (
                // <option key={index} value={subItem.value}>
                    {value: subItem.value}
                // </option>
            ));
        }
    }
 
    return fallbackData?.map((item, index) => ({
        label:item,
        value:item
    }
    ));
};
 
export const renderOptionsformultiple = (options, criteria, fallbackData = []) => {
    const acc = [];
 
    // Find the matching option group by name (e.g., "SHIFTTIMINGS")
    const val = options?.find((item) => item?.name === criteria.name);
 
    if (val) {
        const itemData = val.data;
 
        if (Array.isArray(itemData)) {
            // Filter for active status and flag=true
            const data = itemData
                .filter(subItem => subItem.status === "active" && subItem.flag === true)
                .map(subItem => ({
                    label: subItem.name,
                    value: subItem.name
                }));
 
            // Push if data is found
            if (data.length > 0) {
                acc.push(...data);
            }
        }
    }
 
    // If no data matched or val wasn't found, use fallback
    if (acc.length === 0 && fallbackData.length > 0) {
        const menu = fallbackData.map(item => ({
            label: item.label,
            value: item.value
        }));
        acc.push(...menu);
    }
 
    return acc;
};
 
export function getOptionsByPath(data, pathIds = []) {
  let currentLevel = data;
  let currentNode = null;
 
  for (const id of pathIds) {
    currentNode = currentLevel.find(item => item._id === id);
    if (!currentNode) return [];
    currentLevel = currentNode.children || [];
  }
 
  const options = currentNode?.children || currentLevel || [];
  return options.map(opt => ({
    label: opt.name,
    value: opt.name,
    id: opt._id,
  }));
}
 
 
export function useNestedDropdownHandler(options, fieldName) {
 
  const [selectedId, setSelectedId] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);

  const handleChange = useCallback(
    (value, onValueChange) => {
      const selectedOption = options.find(opt => opt.value === value);
      if (selectedOption) {
        setSelectedId(selectedOption.id);
        setSelectedValue(selectedOption.value);

        if (typeof onValueChange === "function") {
          onValueChange({
            target: {
              name: fieldName,
              value: selectedOption?.value,
              id: selectedOption?.id,
            },
          });
        }
      } else {
        setSelectedId(null);
        setSelectedValue(null);
      }
    },
    [options, fieldName]
  );

  // Add a reset function to clear selection
  const reset = useCallback(() => {
    setSelectedId(null);
    setSelectedValue(null);
  }, []);

  return { selectedId, selectedValue, handleChange, reset };
}
